module.exports = __webpack_public_path__ + "assets/pagoTarjetaEntregad0730abc.png";